import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import componentMapping from "./componentMapping";


const renderComponent = (component, index) => {
  const Component = componentMapping[component.type];
  if (!Component) {
    console.error(`Component type "${component.type}" not defined.`);
    return null;
  }

  return (
    <Component key={index} {...component.props}>
      {component.children &&
        component.children.map((child, childIndex) =>
          renderComponent(child, childIndex)
        )}
    </Component>
  );
};

const PageRenderer = ({ pageData }) => {
  const { title, meta, components } = pageData;

  return (
    <div>
      {/* Dynamic SEO Meta Tags */}
      <HelmetProvider>
      <Helmet>
        <title>{title}</title>
        {meta?.description && (
          <meta name="description" content={meta.description} />
        )}
        {meta?.keywords && <meta name="keywords" content={meta.keywords} />}
        {meta?.ogTitle && (
          <meta property="og:title" content={meta.ogTitle} />
        )}
        {meta?.ogDescription && (
          <meta property="og:description" content={meta.ogDescription} />
        )}
        {meta?.canonical && (
          <link rel="canonical" href={meta.canonical} />
        )}
      </Helmet>
      </HelmetProvider>
      
      {/* Render Components Dynamically */}

      <h2 className="page-title">{title}</h2>
      {components.map((component, index) => 
          renderComponent(component, index)
      )}
    </div>
  );
};

export default PageRenderer;
